import { render, staticRenderFns } from "./CheckTerms.vue?vue&type=template&id=01d9f756&scoped=true&"
import script from "./CheckTerms.vue?vue&type=script&lang=js&"
export * from "./CheckTerms.vue?vue&type=script&lang=js&"
import style0 from "./CheckTerms.vue?vue&type=style&index=0&id=01d9f756&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9f756",
  null
  
)

export default component.exports